"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var post = function post(url, data, callback) {
  var request = new XMLHttpRequest();

  request.onload = function () {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      callback(JSON.parse(request.response));
    } else {
      // We reached our target server, but it returned an error
      callback([]);
    }
  };

  request.onerror = function () {
    // There was a connection error of some sort
    callback([]);
  };

  request.open('POST', url, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send(data);
};
/**
 * Requests dictionary items from server
 * @param {Object<string,Object<string,string>>} dictionary
 * @param {function} callback
 * @param {string|null} language
 * @example
 *
 * import { getDictionaryTexts } from '@demant/wdh';
 *
 * const defaultDictionary = {
 *  MyDictionaryGroup: {
 *    SomeKey: SomeDefaultValue,
 *    AnotherKey: AnotherDefaultValue,
 *  }
 * }
 * getDictionaryTexts(defaultDictionary, () => {
 *  console.log(defaultDictionary.MyDictionaryGroup.SomeKey) // Will be the loaded value from Sitecore, if it exists otherwise the default value
 * });
 */


var getDictionaryTexts = function getDictionaryTexts(dictionary, callback, language) {
  var _dictionary = [];
  Object.keys(dictionary).forEach(function (dictionaryGroup) {
    Object.keys(dictionary[dictionaryGroup]).forEach(function (dictionaryKey) {
      _dictionary.push({
        key: "".concat(dictionaryGroup, "/").concat(dictionaryKey),
        text: dictionary[dictionaryGroup][dictionaryKey]
      });
    });
  });

  if (language === null) {
    if (typeof document !== 'undefined') {
      language = document.querySelector('html').getAttribute('lang');
    }
  }

  var url = language ? '/webservices/dictionary.svc/gettextslanguage/'.concat(language) : '/webservices/dictionary.svc/gettexts';
  post(url, JSON.stringify(_dictionary), function (data) {
    if (data instanceof Array) {
      data.forEach(function (value) {
        var keyPart = value.key.split('/');
        dictionary[keyPart[0]][keyPart[1]] = value.text;
      });
    }

    callback();
  });
};

var _default = getDictionaryTexts;
exports["default"] = _default;